import { useEffect } from 'react';

const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Archivo:wght@600;700&family=IBM+Plex+Mono:wght@400;500&family=IBM+Plex+Sans:wght@400;500;600&display=swap';
const LINK_ID = 'landing-fonts';

/**
 * The app self-hosts only Roboto. The landing page's display and mono faces are
 * loaded on mount instead of from index.html, so the driver app and dashboard —
 * which never use them — don't pay for the request.
 */
export const useLandingFonts = () => {
  useEffect(() => {
    if (document.getElementById(LINK_ID)) return;

    const link = document.createElement('link');
    link.id = LINK_ID;
    link.rel = 'stylesheet';
    link.href = FONT_HREF;
    document.head.appendChild(link);
  }, []);
};
